export enum TaskComposerDataEventObjectsEnum {
  CREATE = 'create',
  CANCEL = 'cancel',
  VIEW = 'view',
  TEMPLATE_SELECT = 'template_select',
  DESCRIPTION_EDIT = 'description_edit',
}
